if (!customElements.get('variant-description')) {
  customElements.define(
    'variant-description',
    class VariantDescription extends HTMLElement {
      constructor() {
        super();
        this.variantChangeUnsubscriber = undefined;
        this.productUrl = this.dataset.url;
        this.sectionId = this.dataset.section;
      }

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          // Only respond to variant changes for this section
          if (event.data.sectionId !== this.sectionId) return;
          
          const variant = event.data.variant;
          if (!variant) return;

          // Update the description content
          this.updateDescription(variant.id);
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      updateDescription(variantId) {
        if (!variantId) return;

        // Fetch the product page with the selected variant
        fetch(`${this.productUrl}?variant=${variantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            
            // Find the description element in the fetched HTML
            const updatedDescription = html.querySelector(`#variant-description-${this.sectionId}`);
            const currentDescription = document.querySelector(`#variant-description-${this.sectionId}`);
            
            if (updatedDescription && currentDescription) {
              // Update the description content
              currentDescription.innerHTML = updatedDescription.innerHTML;
            }
          })
          .catch((error) => {
            console.error('Error updating variant description:', error);
          });
      }
    }
  );
}
